import script from "./GeneralPCCase.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralPCCase.vue?vue&type=script&setup=true&lang=js"

import "./GeneralPCCase.vue?vue&type=style&index=0&id=8ca1122c&lang=scss&scoped=true"
import "./GeneralPCCase.vue?vue&type=style&index=1&id=8ca1122c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ca1122c"]])

export default __exports__